export function useDrawCore(ctx) {
    const vm = ctx.vm;
    const getBarsSafe = () => {
        const bars = ctx.getBars();
        return Array.isArray(bars) ? bars : [];
    };
    const dist2 = (ax, ay, bx, by) => {
        const dx = ax - bx;
        const dy = ay - by;
        return dx * dx + dy * dy;
    };
    const newGroupId = (prefix = "grp") =>
        `${prefix}_${Date.now()}_${Math.random().toString(16).slice(2)}`;
    const pickPointFromMouse = (mx, my) => {
        const chart = ctx.chart();
        const paneId = ctx.getMainPaneId();
        const res = chart.convertFromPixel?.({ x: mx, y: my }, { paneId });
        const bars = getBarsSafe();
        const dataIndex = Number(res?.dataIndex);
        const value = Number(res?.value);
        if (!Number.isFinite(dataIndex) || !bars?.[dataIndex]) return null;
        if (!Number.isFinite(value)) return null;
        return { timestamp: bars[dataIndex].timestamp, value, dataIndex };
    };
    const pointToPixel = (point) => {
        const chart = ctx.chart();
        const paneId = ctx.getMainPaneId();
        const idx = ctx.getIndexByTs(point.timestamp);
        if (!Number.isFinite(idx)) return null;
        const px = chart.convertToPixel?.({ dataIndex: idx, value: point.value }, { paneId });
        if (!px) return null;
        return { x: Number(px.x), y: Number(px.y) };
    };
    const createOverlayTracked = (payload) => {
        const chart = ctx.chart();
        const id = chart.createOverlay(payload);
        if (id == null) return null;
        const meta = {
            name: payload.name,
            paneId: payload.paneId,
            groupId: payload.groupId || null,
            points: payload.points ? JSON.parse(JSON.stringify(payload.points)) : [],
            extendData: payload.extendData ? JSON.parse(JSON.stringify(payload.extendData)) : undefined,
            styles: payload.styles ? JSON.parse(JSON.stringify(payload.styles)) : undefined,
            zLevel: payload.zLevel ?? 0,
        };
        vm.overlayMeta.set(id, meta);
        vm.drawing.createdIds.push(id);
        return id;
    };
    const removeTracked = (id) => {
        const chart = ctx.chart();
        const meta = vm.overlayMeta.get(id);
        if (!meta) return;
        if (meta.groupId) {
            chart.removeOverlay?.({ groupId: meta.groupId });
            for (const [oid, om] of Array.from(vm.overlayMeta.entries())) {
                if (om.groupId !== meta.groupId) continue;
                vm.overlayMeta.delete(oid);
                vm.stickerStore.delete(oid);
                vm.drawing.createdIds = (vm.drawing.createdIds || []).filter((x) => x !== oid);
                if (vm.hoverStickerId === oid) vm.hoverStickerId = null;
                if (vm.selectedOverlayId === oid) vm.selectedOverlayId = null;
            }
            return;
        }
        chart.removeOverlay?.({ id });
        vm.overlayMeta.delete(id);
        vm.stickerStore.delete(id);
        vm.drawing.createdIds = (vm.drawing.createdIds || []).filter((x) => x !== id);
        if (vm.hoverStickerId === id) vm.hoverStickerId = null;
        if (vm.selectedOverlayId === id) vm.selectedOverlayId = null;
    };
    const localToWorld = (center, pt, scale, angle) => {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const x = pt.x * scale;
        const y = pt.y * scale;
        return {
            x: center.x + (x * cos - y * sin),
            y: center.y + (x * sin + y * cos),
        };
    };
    const placeAnnBox = (left, top) => {
        ctx.nextTick(() => {
            const el = ctx.refs().annBox;
            if (!el) return;
            el.style.left = left + "px";
            el.style.top = top + "px";
        });
    };
    const placeCtxMenu = (x, y) => {
        ctx.nextTick(() => {
            const el = ctx.refs().ctxMenu;
            if (!el) return;
            el.style.left = x + "px";
            el.style.top = y + "px";
        });
    };
    return {
        getBarsSafe,
        dist2,
        newGroupId,
        pickPointFromMouse,
        pointToPixel,
        localToWorld,
        createOverlayTracked,
        removeTracked,
        placeAnnBox,
        placeCtxMenu,
    };
}
